import { secondsToMilliseconds } from 'date-fns';

export const TRANSCRIPTION_NOT_AVAILABLE_FOR_MULTIPLE_PARTICIPANTS =
  'Transcription is not available for sessions with multiple participants';
export const TRANSCRIPTION_DISABLED_TOAST_TIMEOUT = secondsToMilliseconds(20);
export const CONSENT_TOAST_DURATION_MS = secondsToMilliseconds(30);

export const NO_ACCESS_CAMERA_TOAST_KEY = 'no-access-camera';
export const CAMERA_TAKEN_TOAST_KEY = 'camera-taken';

export const PATIENT_OPTED_OUT_OF_SESSION_SUMMARIZATION =
  'This client has chosen not to consent to AI-enabled session summarization';
export const TRANSCRIPTION_PAUSED_LOGIN_REQUIRED = 'Please re-login to enable transcription';
